import { createSlice } from "@reduxjs/toolkit";

const ArtworkViewSlice = createSlice({
  name: "ArtworkView",
  initialState: {
    loading: false,
    items: [],
    error: null,
  },
  reducers: {
    fetchArtworkRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
   fetchArtworkSuccess: (state, action) => {
  state.loading = false;
  state.items = action.payload; // always array
},
    fetchArtworkFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetArtworkView: (state) => {
      state.loading = false;
      state.items = [];
      state.error = null;
    }
  },
});

export const {
  fetchArtworkRequest,
  fetchArtworkSuccess,
  fetchArtworkFailure,
  resetArtworkView
} = ArtworkViewSlice.actions;

export default ArtworkViewSlice.reducer;
